import { axios } from '@getgreenline/homi-shared'
import Endpoints from '../../../constants/Endpoints'

const BASE_PATH = `${Endpoints.PLATFORM_GATEWAY_URL}/menu-service/api/v1`

interface IJsonApiResource<TAttributes> {
  id: string
  type: string
  attributes: TAttributes
}

interface IJsonApiListResponse<TAttributes> {
  data: Array<IJsonApiResource<TAttributes>>
}

interface IJsonApiSingleResponse<TAttributes> {
  data: IJsonApiResource<TAttributes>
}

interface IChannelAttributes {
  name: string
  environment: 'US' | 'GL'
  active: boolean
  createdAt?: string
  updatedAt?: string
}

export interface ISalesChannel {
  id: string
  name: string
  environment: 'US' | 'GL'
  active: boolean
  createdAt?: string
  updatedAt?: string
}

export const getSalesChannels = async (): Promise<ISalesChannel[]> => {
  const res = await axios.get<IJsonApiListResponse<IChannelAttributes>>(
    `${BASE_PATH}/admin/channels`,
    {
      params: { 'page[size]': 50 },
    },
  )

  return (res.data.data ?? []).map((channel) => ({
    id: channel.id,
    name: channel.attributes.name,
    environment: channel.attributes.environment,
    active: channel.attributes.active,
    createdAt: channel.attributes.createdAt,
    updatedAt: channel.attributes.updatedAt,
  }))
}

export const createSalesChannel = async (
  name: string,
  environment: 'US' | 'GL',
  active: boolean,
): Promise<ISalesChannel> => {
  const res = await axios.post<IJsonApiSingleResponse<IChannelAttributes>>(
    `${BASE_PATH}/admin/channels`,
    {
      data: {
        type: 'channels',
        attributes: {
          name,
          environment,
          active,
        },
      },
    },
  )

  return {
    id: res.data.data.id,
    name: res.data.data.attributes.name,
    environment: res.data.data.attributes.environment,
    active: res.data.data.attributes.active,
    createdAt: res.data.data.attributes.createdAt,
    updatedAt: res.data.data.attributes.updatedAt,
  }
}

export const updateSalesChannel = async (
  channelId: string,
  name: string,
  environment: 'US' | 'GL',
  active: boolean,
): Promise<ISalesChannel> => {
  const res = await axios.put<IJsonApiSingleResponse<IChannelAttributes>>(
    `${BASE_PATH}/admin/channels/${channelId}`,
    {
      data: {
        type: 'channels',
        attributes: {
          name,
          environment,
          active,
        },
      },
    },
  )

  return {
    id: res.data.data.id,
    name: res.data.data.attributes.name,
    environment: res.data.data.attributes.environment,
    active: res.data.data.attributes.active,
    createdAt: res.data.data.attributes.createdAt,
    updatedAt: res.data.data.attributes.updatedAt,
  }
}
